import {
  setSearchLoadMoreError,
  setSearchPagination,
} from "../sharepointSlice";
import { searchSharepoint } from "./searchSharepoint";

export const retrySearchLoadMore = () => (dispatch) => {
  dispatch(setSearchLoadMoreError(false));
  dispatch(setSearchPagination({ pagination: { hasMore: true } }));
  return dispatch(searchSharepoint());
};
